import React from 'react';
import { heroData } from '../data/mock';
import { ArrowRight, Scale } from 'lucide-react';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="hero" 
      className="relative min-h-screen flex items-center overflow-hidden bg-[#f8fafc]"
      style={{ padding: '120px 0 80px' }}
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <img 
          src={heroData.backgroundImage} 
          alt="Legal documents" 
          className="w-full h-full object-cover absolute inset-0"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#f8fafc] via-[#f8fafc]/95 to-[#f8fafc]/80" />
        <div className="absolute inset-0 bg-[#f8fafc]/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[87.5rem] mx-auto px-10 w-full">
        <div className="max-w-3xl">
          {/* Attorney Badge */}
          <div className="inline-flex items-center gap-2 bg-[#3b82f6]/10 border border-[#3b82f6]/30 rounded-full px-4 py-2 mb-6">
            <Scale size={16} className="text-[#3b82f6]" />
            <span className="text-[#3b82f6] text-sm font-semibold uppercase tracking-wide">
              {heroData.tagline}
            </span>
          </div>

          {/* Subheadline */}
          <div className="mb-4">
            <span className="text-[#64748b] text-sm font-medium uppercase tracking-[0.1em]">
              {heroData.subheadline}
            </span>
          </div>

          {/* Main Headline */}
          <h1 
            className="text-[#0f172a] font-black uppercase leading-[0.9] mb-8"
            style={{ 
              fontFamily: "'Inter', Arial, sans-serif",
              fontSize: 'clamp(3rem, 5vw + 1rem, 5.5rem)',
              letterSpacing: '-0.02em'
            }}
          >
            {heroData.headline}
          </h1>

          {/* Description */}
          <p className="text-[#475569] text-xl font-medium leading-relaxed mb-10 max-w-xl">
            {heroData.description}
          </p>

          {/* CTA Button */}
          <button 
            onClick={scrollToContact}
            className="group bg-[#3b82f6] text-white border-none rounded-[10rem] px-8 py-4 font-semibold text-base cursor-pointer transition-all duration-300 hover:bg-[#2563eb] hover:scale-[1.02] active:scale-[0.98] uppercase tracking-tight inline-flex items-center gap-3"
          >
            {heroData.ctaText}
            <ArrowRight size={20} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
};

export default HeroSection;
